<div class="involved-details">
    <div class="involved-info-container">
        <form [formGroup]="involvedForm">
            <div class="form-group">
                <single-choice
                    class="single-choice"
                    formControlName="involved"
                    [completedUrl]="completionUrl"
                    [topic]="'users'"
                    [editMode]="TRUE"
                    [ticketId]="currentId"
                    (choiceEvent)="relaySingleChoice($event)"
                    [labelOnDemand]="userIdLabelerByService"
                    [choiceObserver]="userIdObserver" 
                    ></single-choice>

                <div class="action-buttons" *ngIf="showSaveButton">
                    <button class="plus" type="button" (click)="saveInvolved()">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                </div>

                <messages
                    class="message"
                    [form]="involvedForm"
                    [messagesObserver]="messages"
                    fieldname="user"
                    ></messages>
            </div>

            <messages
                class="message"
                [form]="involvedForm"
                [messagesObserver]="messages"
                fieldname="involved"
                [showNonFieldKeys]="TRUE"
                [showFieldName]="TRUE"
                [showFieldKeys]="FALSE"
                ></messages>
        </form>
    </div>
</div>